import { AvailableUserGroupRealtimeData } from 'src/generated/signalR/available-user-group-realtime-data';

export class AvailableUserGroupsUpdated {
   public static readonly type = '[available users] Updated';

   constructor(public data: AvailableUserGroupRealtimeData) {}
}
